<p
    class="m-24:v"
    [ngClass]="{ 'md:m-32:v lg:m-48:v': !smallMargins }"
>
    Bitte fülle alle mit <span class="c:blue-700">*</span> gekennzeichneten Felder aus.
</p>
